import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter, push } from 'connected-react-router'
import { errors } from '@ocean/ui'
import { history } from 'store'
import { CommunicationIFrameLayer, InitializationLayer, UserDeclarationLayer } from 'core/layers'
import { ApplicationError } from 'components/errors'
import AssessmentPlayerRoutes from 'modules/AssessmentPlayer/routes'
import { routes as authRoutes } from 'modules/Auth/routing'
import { routes as ssoRoutes } from 'modules/Sso/routing'
import StatusRouting, { routes as statusRoutes } from 'modules/Status/routing'
import MobileNativeRedirectRouting, {
  routes as mobileNativeRedirectRoutes,
} from 'modules/redirects/MobileNativeRedirect/routing'
import ProxyRedirectRouting, {
  routes as proxyRedirectRoutes,
} from 'modules/redirects/ProxyRedirect/routing'
import StaRedirectRouting, {
  routes as staRedirectRoutes,
} from 'modules/redirects/StaRedirect/routing'
import requirementsRoutes from 'modules/requirements/common/routing/routes'
import ExternalRouting from './ExternalRouting'
import PrivateRouting from './PrivateRouting'
import rootRoutes from './routes'

const { ErrorBoundary } = errors

const RootRouting = () => {
  const dispatch = useDispatch()

  // By setting up this popstate event listener, we prevent the user from navigating back to the assessment page (AssessmentPlayerRoutes.root).
  //  Instead, we redirect them to requirementsRoutes.root with showAdaptiveLearning=true.
  useEffect(() => {
    window.onpopstate = e => {
      if (window.location.pathname.includes(AssessmentPlayerRoutes.root)) {
        dispatch(push(`${requirementsRoutes.root}?showAdaptiveLearning=true`))
      }
    }
  }, [dispatch])
  return (
    <ConnectedRouter history={history}>
      <ErrorBoundary FallbackComponent={ApplicationError}>
        <InitializationLayer>
          <UserDeclarationLayer>
            <CommunicationIFrameLayer>
              <Switch>
                <Route path={staRedirectRoutes.root} component={StaRedirectRouting} />
                <Route path={proxyRedirectRoutes.root} component={ProxyRedirectRouting} />
                <Route
                  path={mobileNativeRedirectRoutes.root}
                  component={MobileNativeRedirectRouting}
                />
                <Route path={statusRoutes.root} component={StatusRouting} />
                <Route path={authRoutes.root} component={ExternalRouting} />
                <Route path={ssoRoutes.root} component={ExternalRouting} />
                <Route path={rootRoutes.root} component={PrivateRouting} />
              </Switch>
            </CommunicationIFrameLayer>
          </UserDeclarationLayer>
        </InitializationLayer>
      </ErrorBoundary>
    </ConnectedRouter>
  )
}

export default RootRouting
